/** Renders a Google Calendar event as a dashed, italic row distinct from native tasks. */
import { Box } from '@mui/material';
import {
  gcalEventItemSx,
  gcalEventItemDenseSx,
} from '@/components/ui/taskVisualTokens';
import {
  getGCalEventClockTime,
  isGCalAllDayEvent,
} from '@/features/planning/utils/gcalHorizonUtils';

const untitled = '(No title)';

const formatRangeTitle = (event) => {
  const summary = event.summary || untitled;
  if (isGCalAllDayEvent(event) || !event.start?.dateTime) return summary;
  const start = new Date(event.start.dateTime);
  const end = event.end?.dateTime ? new Date(event.end.dateTime) : null;
  const startLabel = start.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
  if (!end) return `${summary} (${startLabel})`;
  const endLabel = end.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${summary} (${startLabel} - ${endLabel})`;
};

export default function GCalEventItem({ event, dense = false }) {
  const summary = event.summary || untitled;
  const showTime = !isGCalAllDayEvent(event);
  const clock = showTime ? getGCalEventClockTime(event) : null;

  return (
    <Box
      data-testid="gcal-event-item"
      data-dense={dense ? 'true' : undefined}
      title={formatRangeTitle(event)}
      sx={dense ? gcalEventItemDenseSx : gcalEventItemSx}
    >
      {clock ? `${clock} ${summary}` : summary}
    </Box>
  );
}
